/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as l from "react";
import { classNames as h } from "@progress/kendo-react-common";
class x extends l.Component {
  render() {
    const {
      id: a,
      size: e,
      collapsed: s,
      overlay: t,
      containsSplitter: o,
      collapsible: r,
      resizable: n,
      scrollable: i,
      keepMounted: p,
      style: c,
      className: d
    } = this.props, m = e && e.length > 0, k = {
      flexBasis: e,
      ...c
    }, v = h(
      "k-pane",
      {
        "k-hidden": s,
        hidden: s,
        "k-pane-flex": o,
        "k-pane-static": !n && !r || m,
        "k-scrollable": i
      },
      d
    );
    return /* @__PURE__ */ l.createElement("div", { id: a, role: "group", style: k, className: v }, !s || p ? this.props.children : void 0, t ? /* @__PURE__ */ l.createElement("div", { className: "k-splitter-overlay k-overlay" }) : void 0);
  }
}
export {
  x as SplitterPane
};
